import React, { memo } from 'react'
import { Grid } from '@mui/material'
import { SchemaMeta } from './types/dataForm/types'
import DataFormInput from './DataFormInput'
import { formitMeta } from './formit'
import { useFormState } from 'react-hook-form'

interface DataFormProps {
  form: any
  schema: any
  isUpdate?: boolean
}

function DataForm({ form, schema, isUpdate }: DataFormProps) {
  const schemaMetas = Object.keys(schema?.fields).map((name) =>
    formitMeta(schema, name),
  )

  return (
    <Grid container spacing={2}>
      {schemaMetas.map((meta: SchemaMeta, index) => {
        const fields = meta?.fields || null

        return (
          <Grid item key={index} sm={meta.col} xs={12}>
            <DataFormInput
              meta={{ ...meta, isUpdate }}
              form={form}
              name={`${meta.name}`}
              mb={meta.mb ?? 0}
            />
          </Grid>
        )

        //return fields.map((item, index) => (
        //  <Grid key={index} item sm={item.col} xs={12}>
        //    <DataFormInput
        //      key={`${meta.name}.${item.name}`}
        //      name={`${meta.name}.${item.name}`}
        //      meta={item}
        //      form={form}
        //      mb={meta.mb ?? 0}
        //    />
        //  </Grid>
        //))
      })}
    </Grid>
  )
}

export default memo(DataForm)
